import React from 'react';
import { Typography } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface SectionTitleFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const SectionTitleField: React.FC<SectionTitleFieldProps> = ({
    field,
    value,
    onChange,
    disabled = false
}) => {
    const variant = (field.properties?.variant) || 'h4';
    const align = (field.properties?.align) || 'left';
    const text = field.properties?.text || field.label;

    return (
        <Typography
            variant={variant}
            align={align}
            sx={{
                color: 'text.primary',
                mb: 1,
            }}
        >
            {text}
        </Typography>
    );
};

export default SectionTitleField;
